var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardEntity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 298.3 210.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #231f20;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M228.2,171.2H18.9c-3.9,0-7.1-3.2-7.1-7.1V18.9c0-3.9,3.2-7.1,7.1-7.1h221.2c3.9,0,7.1,3.2,7.1,7.1v32c0,3.2,2.6,5.9,5.9,5.9s5.9-2.6,5.9-5.9V18.9c0-10.4-8.5-18.9-18.9-18.9H18.9C8.5,0,0,8.5,0,18.9v145.2c0,10.4,8.5,18.9,18.9,18.9h81.6v16.2h-12.2c-3.3,0-5.9,2.6-5.9,5.9s2.6,5.9,5.9,5.9h82.5c3.3,0,5.9-2.6,5.9-5.9s-2.6-5.9-5.9-5.9h-12.2v-16.2h69.6c3.3,0,5.9-2.6,5.9-5.9s-2.6-5.9-5.9-5.9ZM146.8,182.9v16.2h-34.4v-16.2h34.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.9,45.1c-26,0-47.1,21-47.1,46.9s21.1,46.9,47.1,46.9,47.1-21,47.1-46.9-2.6-5.9-5.9-5.9h-35.3v-35.2c0-3.2-2.6-5.9-5.9-5.9ZM72.9,97.9h34.8c-2.8,16.8-17.4,29.3-34.8,29.3s-35.3-15.8-35.3-35.2,12.5-31.9,29.4-34.7v34.7c0,3.2,2.6,5.9,5.9,5.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M136.2,75.9c0-25.9-21.1-46.9-47.1-46.9s-5.9,2.6-5.9,5.9v41c0,3.2,2.6,5.9,5.9,5.9h9.9c3.3,0,5.9-2.6,5.9-5.9s-2.6-5.9-5.9-5.9h-4v-28.8c14.7,2.5,26.4,14.1,28.9,28.8h-9.8c-3.3,0-5.9,2.6-5.9,5.9s2.6,5.9,5.9,5.9h16.2c3.3,0,5.9-2.6,5.9-5.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M151.1,53.5h35.4c3.3,0,5.9-2.6,5.9-5.9s-2.6-5.9-5.9-5.9h-35.4c-3.3,0-5.9,2.6-5.9,5.9s2.6,5.9,5.9,5.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M198.4,70.2h-47.3c-3.3,0-5.9,2.6-5.9,5.9s2.6,5.9,5.9,5.9h47.3c3.3,0,5.9-2.6,5.9-5.9s-2.6-5.9-5.9-5.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M151.1,110.4h39c3.3,0,5.9-2.6,5.9-5.9s-2.6-5.9-5.9-5.9h-39c-3.3,0-5.9,2.6-5.9,5.9s2.6,5.9,5.9,5.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M151.1,138.9h47.3c3.3,0,5.9-2.6,5.9-5.9s-2.6-5.9-5.9-5.9h-47.3c-3.3,0-5.9,2.6-5.9,5.9s2.6,5.9,5.9,5.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.1,74.5h0c-8.5-8.5-19.8-13.1-31.9-13.1s-23.3,4.7-31.9,13.1c-8.5,8.5-13.2,19.7-13.2,31.7,0,12,4.7,23.3,13.2,31.7,8.5,8.5,19.8,13.1,31.9,13.1s23.4-4.7,31.9-13.1c17.6-17.5,17.6-45.9,0-63.4ZM253.2,73.1c8.9,0,17.2,3.4,23.5,9.7,13,12.9,13,33.9,0,46.8-13,12.9-34.1,12.9-47,0-6.3-6.2-9.7-14.6-9.7-23.4s3.5-17.2,9.7-23.4c6.3-6.3,14.6-9.7,23.5-9.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M259.1,163.6v-5c0-3.2-2.6-5.9-5.9-5.9s-5.9,2.6-5.9,5.9v5c-5.3,2.3-8.8,7.5-8.8,13.4v19.3c0,8.1,6.6,14.7,14.7,14.7s14.7-6.6,14.7-14.7v-19.3c0-5.8-3.5-11-8.8-13.4ZM253.2,199.1c-1.6,0-2.9-1.3-2.9-2.9v-19.3c0-1.6,1.3-2.9,2.9-2.9s2.9,1.3,2.9,2.9v19.3c0,1.6-1.3,2.9-2.9,2.9Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardEntity);
export default __webpack_public_path__ + "static/media/dashboard_entity.df3ed37036309184f22aed3bd9778e81.svg";
export { ForwardRef as ReactComponent };